import { getRequest, postRequest, deleteRequest } from "./api";

/**
 * Upload generated PDF with question_paper_id
 * @param {string} questionPaperId - Selected question paper ID
 * @param {Blob|File} pdfFile - Final PDF blob or File
 * @returns {Promise<any>}
 */
export const uploadQuestionPaper = async (questionPaperId, pdfFile) => {
  const formData = new FormData();
  formData.append("question_paper_id", questionPaperId);
  formData.append("pdf_file", pdfFile);

  return await postRequest(
    "/questionpaper/questionpaper-downloads/",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

/**
 * Get all uploaded question papers
 * @returns {Promise<any>}
 */
export const getQuestionPapers = async () => {
  return await getRequest("/questionpaper/questionpaper-downloads/");
};

/**
 * Download a question paper by ID
 * @param {string} id - ID of the question paper download entry
 */
export const downloadQuestionPaper = async (id) => {
  try {
    const response = await fetch(
      `/questionpaper/questionpaper-downloads/${id}/download/`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `question_paper_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Download error:", error);
  }
};
// Delete a question paper by ID
export const deleteQuestionPaper = async (id) => {
  return await deleteRequest(`/questionpaper/questionpaper-downloads/${id}/`);
};